
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.525 24.25l-5.4-5.45a.238.238 0 00-.212-.087.3.3 0 00-.213.1l-3.6 3.813a2.5 2.5 0 01-1.812.787 2.5 2.5 0 01-1.813-.787l-7.725-8.238a.3.3 0 00-.4 0L2.325 23.763l-1.55-2.012 11.975-9.375a2.788 2.788 0 013.75.3l7.713 8.237 3.575-3.812a2.776 2.776 0 012-.888 2.726 2.726 0 012.025.825l5.4 5.45-1.688 1.763z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M32.85 37.75H5.15a4.9 4.9 0 01-4.9-4.9V5.15a4.9 4.9 0 014.9-4.9h27.7a4.9 4.9 0 014.9 4.9v27.7a4.9 4.9 0 01-4.9 4.9zm-27.7-35a2.4 2.4 0 00-2.4 2.4v27.7a2.4 2.4 0 002.4 2.4h27.7a2.4 2.4 0 002.4-2.4V5.15a2.4 2.4 0 00-2.4-2.4H5.15z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M24.412 13.79a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.5 23.373l11.912-9.587 2.2-.263 7.213 7.7s1.25 1.713 2.313.538l3.587-3.813s.712-1.562 2.237 0c1.525 1.563 5.538 6.675 5.538 6.675l-.087 9.038s-.375 2.837-4.05 2.837-27.5-.387-27.5-.387-3.363.825-3.363-3.263v-9.475z","fill":"#E2E8F0"}})])
          )
        }
      }
    